module.exports = __webpack_public_path__ + "img/DSC_0319.37b708ff.jpg";